import { render } from "./WithdrawList.vue?vue&type=template&id=cb324f1e&scoped=true"
import script from "./WithdrawList.vue?vue&type=script&lang=js"
export * from "./WithdrawList.vue?vue&type=script&lang=js"

import "./WithdrawList.vue?vue&type=style&index=0&id=cb324f1e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb324f1e"]])

export default __exports__